__turbopack_context__.v({
  "close-button": "SubdomainInfoTooltip-module-scss-module__3X8aga__close-button",
  "explainer-wrapper": "SubdomainInfoTooltip-module-scss-module__3X8aga__explainer-wrapper",
  "info-icon": "SubdomainInfoTooltip-module-scss-module__3X8aga__info-icon",
});
